import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  Alert,
} from "reactstrap";
import { Field, reduxForm, formValueSelector } from "redux-form/immutable";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { toJS } from "../../../containers/to-js";
import { resetPassword, resetForgotPasswordState } from "../../../actions/user";
import { getCompanyDetails } from "../../../actions/company";
import isEmail from "validator/lib/isEmail";
import config from "../../../config";

class ForgotPassword3 extends Component {
  componentDidMount() {
    localStorage.removeItem("user");
    const { companyDetails } = this.props;
    if (companyDetails.data == null) {
      this.props.getCompanyDetails();
    }
  }
  renderField({ input, label, type, placeholder, meta: { touched, error } }) {
    return (
      <>
        <Input placeholder={placeholder} type={type} {...input} required />
        <div className="standard-line"></div>
        <Label for={input.name}>
          {label} <span className="asterick-mark">*</span>
        </Label>
        {touched && error && (
          <small className="text-danger form-text mt-1 animated fadeIn">
            {error}
          </small>
        )}
      </>
    );
  }
  componentWillUnmount() {
    this.props.resetForgotPasswordState();
  }
  render() {
    const {
      handleSubmit,
      forgotPasswordState,
      companyDetails,
      layoutItem,
      reCaptchaComponent,
      displayReCaptcha,
    } = this.props;

    const templateSideImage =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.forgotPasswordConfig &&
      layoutItem.itemProperties.forgotPasswordConfig.templateSideImage &&
      layoutItem.itemProperties.forgotPasswordConfig.templateSideImage.path;

    const sideImageTopLogo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.forgotPasswordConfig &&
      layoutItem.itemProperties.forgotPasswordConfig.sideImageTopLogo &&
      layoutItem.itemProperties.forgotPasswordConfig.sideImageTopLogo.path;

    const topHeadingLogo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.forgotPasswordConfig &&
      layoutItem.itemProperties.forgotPasswordConfig.topHeadingLogo &&
      layoutItem.itemProperties.forgotPasswordConfig.topHeadingLogo.path;    

    const sideImageTopLogoUrl = `${config.assetsBasePath}${sideImageTopLogo}`;
    const topHeadingLogoUrl = `${config.assetsBasePath}${topHeadingLogo}`;
    const authTemplateSideImage = `${config.assetsBasePath}${templateSideImage}`;

    const logoutUrl =
      companyDetails && companyDetails.data && companyDetails.data.logoutURL
        ? companyDetails.data.logoutURL
        : "/login";

    const sideImageTextOne =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.forgotPasswordConfig &&
      layoutItem.itemProperties.forgotPasswordConfig.sideImageTextOne;

    const sideImageTextTwo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.forgotPasswordConfig &&
      layoutItem.itemProperties.forgotPasswordConfig.sideImageTextTwo;

    return (
      <div className="forgot-password-template-3">
        <div className="left-panel">
          {sideImageTopLogoUrl && (
            <img src={sideImageTopLogoUrl} className="left-logo" />
          )}
          <div className="left-para-sec">
            <p>
              {sideImageTextOne} <span>{sideImageTextTwo}</span>
            </p>
          </div>
          {authTemplateSideImage && (
            <img
              src={authTemplateSideImage}
              alt="payment-img"
              className="payment-bg-img"
            />
          )}
        </div>
        <div className="right-panel">
          <div className="inner-right-panel pb-5">
            <div className={`brand-logo`}>
              {topHeadingLogoUrl && <img src={topHeadingLogoUrl} alt="Image" />}
            </div>
            {!forgotPasswordState.isLoading &&
            forgotPasswordState.data !== null ? (
              <div className="alertText">
                <svg
                  class="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  {" "}
                  <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />{" "}
                  <path
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <h4>Thank you for submitting the request!!</h4>
                <p>
                  If the email address is registered with us, you will receive
                  an email with link to reset the password.
                </p>
                <Link className="back-to-login-btn" to={logoutUrl}>
                  Continue to login
                </Link>
              </div>
            ) : (
              <Form onSubmit={handleSubmit}>
                <div className="forgot-pass-div">
                  <h3>Forgot Password</h3>
                  <div className="input-sec">
                    <i
                      className={`fa fa-user forgot-icon`}
                      aria-hidden="true"
                    ></i>
                    <Field
                      name="email"
                      component={this.renderField}
                      type="text"
                      label="Email"
                      placeholder="Enter Email"
                    />
                  </div>
                  {reCaptchaComponent}
                  <Button
                    disabled={forgotPasswordState.isLoading || displayReCaptcha}
                    className="pr-2 pl-2 forgot-btn"
                    color="primary"
                    block
                  >
                    {forgotPasswordState.isLoading
                      ? "Please wait..."
                      : "Reset Password"}
                  </Button>
                  <span className="back-login-link">
                    {`Already registered user?`} &nbsp;
                    <Link to={logoutUrl}>Click here</Link>
                  </span>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    forgotPasswordState: state.getIn(["user", "resetPassword"]),
    translate: getTranslate(state.get("locale")),
    companyDetails: state.getIn(["company", "details"]),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (values) => {
      let reCaptchaDetails = localStorage.getItem("_captcha_details_forgot");
      reCaptchaDetails = JSON.parse(reCaptchaDetails);
      if (!reCaptchaDetails) {
        localStorage.setItem(
          "_captcha_details_forgot",
          JSON.stringify({
            count: 0,
            date: new Date(),
          })
        );
      } else {
        const lastSetDate = reCaptchaDetails.date;
        const currentDate = new Date();
        let diff = Math.abs(currentDate - lastSetDate);
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes > 30) {
          localStorage.setItem(
            "_captcha_details_forgot",
            JSON.stringify({
              count: 0,
              date: new Date(),
            })
          );
        } else {
          localStorage.setItem(
            "_captcha_details_forgot",
            JSON.stringify({
              count: reCaptchaDetails.count + 1,
              date: new Date(),
            })
          );
        }
      }
      dispatch(resetPassword(values));
    },
    resetForgotPasswordState: () => {
      dispatch(resetForgotPasswordState());
    },
    getCompanyDetails: () => {
      dispatch(getCompanyDetails());
    },
  };
};

const validate = (values) => {
  const errors = {};
  const email = values.get("email");
  if (!email || !isEmail(email)) {
    errors.email = "Please provide a valid email address";
  }
  return errors;
};

ForgotPassword3 = reduxForm({
  form: "player-resetpassword-form",
  validate,
})(ForgotPassword3);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(ForgotPassword3));
